// extracted by mini-css-extract-plugin
export default {"footer":"fGdug6DslehtRY_xiXhM","inner":"Vv3SNENxFX8rT1313CNy","links":"MLDGHCHpm4ExOPJcxeh3"};